/**
 * 示例文件
 * 可单独封装接口请求方法
 * 文件根据相应功能模块语义化命名
 * 导出至'@/http/index'
 */
import http from '../http'
import url from '../url'
import Config from '../../config/index'
// 可用优惠券列表
export const getProductsByCouponId = (params) => {
  return http.request({
    url: url.getProductsByCouponId,
    method: 'get',
    params
  })
}
// 新可用优惠券列表
export const getCouponMarketAndStrategyRule = (params) => {
  return http.request({
    url: url.getCouponMarketAndStrategyRule,
    method: 'get',
    params
  })
}

export const getProductsByCardId = (params) => {
  return http.request({
    url: url.getProductsByCardId,
    method: 'get',
    params
  })
}

// 集团卡券-适用商品列表 根据券id和定位获取授权店铺
export const getCouponUseStore = (params) => {
  return http.request({
    url: url.getCouponUseStore,
    method: 'get',
    params
  })
}

// 集团卡券-适用商品列表 根据券id和店铺id获取适用商品
export const getCouponUseProducts = (params) => {
  return http.request({
    url: url.getCouponUseProducts,
    method: 'get',
    params
  })
}

// 根据券id获取加入购物车的商品
export const getCartByCoupon = (params, config) => {
  return http.get(url.getCartByCoupon, { params, ...config })
}

// 优惠券/礼品券适用商品列表页加购提示
export const dealPromptByStrategyFirst = (params) => {
  return http.post(url.dealPromptByStrategyFirst,  params )
}

// 批量获取卡商品最该可优惠金额
export const queryPriceByCardSkus = (params) => {
  return http.post(url.queryPriceByCardSkus, params)
}

// 可优惠商品加入购物车
export const addCartByCoupon = (params) => {
  return http.post(url.addCart, params)
}

// 可用优惠券商品从购物车删除
export const deleteCart = params => {
  // let fetchUrl = params.skus ? url.deleteBatch : url.deleteCart // type 1 单规格删除 2 多规格删除
  return http.get(url.deleteBatch, { params })
}

// 更新购物车数量
export const updateCart = params => {
  return http.post(url.updateCart, params)
}

export const updateCartByNumber = (params, config) => {
  return http.post(url.updateCart, params, config)
}

// 获取多规格商品信息
export const specifications = params => {
  let fetchurl = `${url.productDetailData}${params.productId}.json`
  return http.get(fetchurl, { params, baseURL: Config.DHOST })
}

// 更新多规格商品价格
export const updateSkuPrice = params => {
  return http.get(`${url.getProductBasicInfo}${params.productId}.json`, { params, baseURL: Config.DHOST })
}
//查询券规则信息
export const queryRuleInfoByCoupon = (data,config) => {
  return http.post(url.queryRuleInfoByCoupon,data,{baseURL:Config.UPLUSHOST, ...config})
}
//查询品牌和产品组
export const getCouponBrandAndDepartment = params => {
  return http.get(url.getCouponBrandAndDepartment, { params, baseURL: Config.HOST })
}